import { useGetOffer } from 'legacy/events/hooks';
import React from 'react';
import { IoMdPause } from 'react-icons/io';
import { FaCirclePlay } from 'react-icons/fa6';
import OfferDetailsHeader from '../../offers/offer-details/OfferDetailsHeader';
import OfferDetailsStats from '../../offers/offer-details/OfferDetailsStats';
import PromoterCard from '../../offers/PromoterCard';
import Button, { ButtonType } from 'legacy/common/components/button/Button';
import FadeIn from 'legacy/common/components/transition/FadeIn';

const OfferDetailPage = ({ offerId }: { offerId: string }) => {
  const { data } = useGetOffer(offerId, { enabled: !!offerId });

  // TODO: Add a loading state
  if (!data) {
    return null;
  }

  return (
    <>
      <FadeIn>
        <div className="pt-[36x] md:pt-[90px] -mt-[36px] pb-20 md:w-[630px] md:mx-auto md:px-0 px-4">
          <OfferDetailsHeader data={data} />
          <div
            className={`flex mt-4 items-center justify-center gap-2 border border-[#EFF2FF] rounded-2xl p-2 ${
              !data?.isActive ? 'bg-[#EFF2FF]' : ''
            }`}
          >
            <div className="text-sm font-bold text-[#3853C4]">
              {data?.isActive ? 'Pause Offer' : 'Resume Offer'}
            </div>
            {data?.isActive ? (
              <IoMdPause className="text-[#3853C4]" />
            ) : (
              <FaCirclePlay className="text-[#3853C4]" />
            )}
          </div>
          <OfferDetailsStats />
          <div className="mt-10">
            <div className="text-base font-bold text-[#202020] mb-4">
              Promoters (1)
            </div>
            <PromoterCard />
          </div>
        </div>
      </FadeIn>
      <div className="w-full bg-white fixed bottom-0 left-0 p-4 z-10 border-t pb-12 md:pb-4">
        <div className="w-full md:w-[343px] mx-auto">
          <div className="flex gap-4">
            <Button type={ButtonType.Primary} onClick={() => null}>
              <div className="flex items-center justify-center">Edit offer</div>
            </Button>
          </div>
        </div>
      </div>
    </>
  );
};

export default OfferDetailPage;
